export enum ObjectLockResultEnum {
  OBJECT_HAS_LOCK = 'OBJECT_HAS_LOCK',
  SET_LOCK_OK = 'SET_LOCK_OK',
  OBJECT_HAS_UPD_LOCK = 'OBJECT_HAS_UPD_LOCK',
  MULTI_RESULT = 'MULTI_RESULT',
}
